// createStore.ts
import { createStore as reduxCreateStore } from 'redux'
import rootReducer, { RootState } from './reducers'

const createStore = () =>
  reduxCreateStore<RootState, any, any, any>(rootReducer)
export default createStore
